import styled from 'react-emotion';
import { styled as coreStyled } from '@ublend-npm/aulaui-core';
import { DARK } from '@core/constants/theme';

export const Container = styled('div')`
  position: relative;
  flex-shrink: 0;
  overflow: visible;
  margin-bottom: 24px;
  padding: 8px 16px;
  border-radius: 6px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f8f9fa;
  }
`;

export const EditedLabel = coreStyled('span')(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: 'Roboto, sans-serif',
  color:
    theme.palette.mode === DARK
      ? 'rgba(255, 255, 255, 0.7)'
      : 'rgba(0, 0, 0, 0.6)',
}));

export const MessagesContainer = styled('div')`
  flex-shrink: 0;
  padding-top: 4px;
`;

export const Row = styled('div')`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
